export default __webpack_public_path__ + "static/media/cat.371bb68a.png";